/**
 * fetchRegistry — module-level authorized fetch registry.
 *
 * AuthContext injects authtool's fetch (which attaches Authorization: Bearer <JWT>
 * automatically) after the user authenticates. Non-hook code (service singletons,
 * auth modules) imports getAuthorizedFetch() instead of calling window.fetch directly,
 * so they transparently use the authenticated fetch without needing React hook access.
 *
 * Per spec-auth.md: never call window.fetch directly for authenticated resources.
 */

import { buildAclContextHeaders } from './aclContext'

let _authorizedFetch = window.fetch.bind(window)

export function setAuthorizedFetch(fn) {
  _authorizedFetch = fn
}

// Stable wrapper that injects the `x-mia-acl-context` header (the selected authz
// org/tenant) into every authenticated request, then delegates to the current
// authtool fetch (which adds Authorization: Bearer). Existing headers win.
const _wrappedFetch = (input, init = {}) => {
  const headers = new Headers(init.headers || {})
  for (const [key, value] of Object.entries(buildAclContextHeaders())) {
    if (!headers.has(key)) { headers.set(key, value) }
  }
  return _authorizedFetch(input, { ...init, headers })
}

export function getAuthorizedFetch() {
  return _wrappedFetch
}
